module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_2.663244d6.png";